import { toast } from 'react-toastify';
import { orgSendMessage } from '../../../api/orgTripAPI';
import errorHandle from '../../../utils/errorHandle';

export const sendMessage = async (messageData, setLoading, setModal) => {
    setLoading(true);
    try {
        // if (messageData.msgType !== 'rate' && messageData.msgType !== 'whatsApp' && messageData.message.length < 10) {
        //     toast.error('The message must be more than 10 characters.');
        //     setLoading(false);
        // } else if (
        //     messageData.msgType !== 'rate' &&
        //     messageData.msgType !== 'whatsApp' &&
        //     messageData.message.length > 50
        // ) {
        //     toast.error('The message must be less than 50 characters.');
        //     setLoading(false);
        // } else {
        if (!messageData) {
            toast.error('Message data is missing.');
            setLoading(false);
            setModal(false);
            return;
        }

        if (messageData.msgType === 'whatsApp' && !messageData.whatsApp.trim()) {
            toast.error('Please enter WhatsApp message or whatsApp group link');
            setLoading(false);
            setModal(false);
            return;
        }

        console.log(messageData, 'Message Data');

        await orgSendMessage(messageData);
        // .then((res) => {
        // if (res.status === 200) {
        toast.success('Message sent successfully');
        setModal(false);
        // } else {
        //     toast.error('Error sending message');
        // }
        setLoading(false);
        // });
        // }
    } catch (err) {
        setLoading(false);
        setModal(false);
        errorHandle(err);
    }
};
